import { alpha, Theme } from '@mui/material/styles';

export default function Autocomplete(theme: Theme) {
  const isDark = theme.palette.mode === 'dark';
  return {
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root:not(.MuiInputBase-sizeSmall)': {
            paddingTop: 4.5,
            paddingBottom: 4.5,
          },
        },
        paper: {
          backgroundColor: theme.palette.background.paper,
          backgroundImage: 'none',
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: 12,
          boxShadow: isDark ? '0 16px 40px rgba(0,0,0,0.45)' : '0 12px 32px rgba(15,26,46,0.12)',
        },
        listbox: {
          padding: 6,
          '& .MuiAutocomplete-option': {
            borderRadius: 8,
            marginTop: 2,
            marginBottom: 2,
            transition: theme.transitions.create(['background-color', 'color']),
            '&:hover': {
              backgroundColor: alpha(theme.palette.primary.main, 0.08),
            },
            '&.Mui-focused': {
              backgroundColor: alpha(theme.palette.primary.main, 0.08),
            },
            '&[aria-selected="true"]': {
              backgroundColor: alpha(theme.palette.primary.main, 0.16),
            },
            '&[aria-selected="true"].Mui-focused, &[aria-selected="true"]:hover': {
              backgroundColor: alpha(theme.palette.primary.main, 0.22),
            },
          },
        },
      },
    },
  };
}
